import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// UI Components
import Header from "./components/Header";
import Footer from "./components/Footer";  
import TrackOrder from "./components/TrackOrder";
import Home from "./components/Home";
import ShopByCategory from "./components/ShopByCategory";
import ShopByBrands from "./components/ShopByBrand";
import ServiceRequestForm from "./components/ServiceRequest";
import Sales from "./components/Sale";
import TrendingItems from "./components/TrendingItems";
import TopDiscountedProducts from "./components/TopDiscountedProducts";
import Testimonials from "./components/Testimonials";
import Login from "./components/Login";
import Register from "./components/Register";
import Wishlist from "./components/WishList";
import Cart from "./components/CartPage";
import ProductPage from "./components/ProductPage";
import DescriptionPage from "./components/DescriptionPage";
import Checkout from "./components/Checkout";
import PaymentSuccess from "./components/PaymentSuccess";
import OrdersPage from "./components/Orders";
import ForgotPassword from "./components/ForgotPassword";
import VerifyOtp from "./components/VerifyOtp";
import ResetPassword from "./components/ResetPassword";
import AboutUs from "./components/AboutUs";
import Profile from "./components/Profile";
import ScrollToTop from "./components/ScrollToTop";  
import OrderHistory from "../src/components/OrderHistory";  
import ServiceHistory from "../src/components/ServiceHistory"     
import Content1 from "../src/components/Content1";    
import Content2 from "../src/components/Content2";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Terms from "./components/Terms";
import EmbroideryDesigns from "./components/EmbroideryDesigns";
import EmbroideryDesignDetail from "./components/EmbroideryDesignDetail";
import Blog from "./components/Blog";
import BlogDetail from "./components/BlogDetail";

// Admin Components
import AdminLayout from "./Admin/AdminLayout";
import AdminProtectedRoute from "./Admin/AdminProtectedRoute";
import Dashboard from "./Admin/AdminDashboard";
import Users from "./Admin/Users";
import Technicians from "./Admin/Technicians";
import Products from "./Admin/AdminProducts";
import Settings from "./Admin/AdminSettings";
import Banner from "./Admin/Banner";
import Reviews from "./Admin/Reviews";
import TrendingProducts from "./Admin/TrendingProducts";
import AdminServiceRequest from "./Admin/ServerRequest"; // Renamed for clarity
import Orders from "./Admin/AdminOrders";
import Categories from "./Admin/AdminCategories";
import Brands from "./Admin/Brands";
import OfferBanner from "./Admin/OfferBanner";
import Reports from "./Admin/AdminReports";      
import AdminAboutUs from "../src/Admin/AdminAboutUs";      
import AdminContent1 from "../src/Admin/AdminContent1";    
import AdminContent2 from "../src/Admin/AdminContent1";
import TechnicianLocations from "./Admin/TechnicianLocations";
import AdminEmbroideryDesigns from "./Admin/AdminEmbroideryDesigns";
import AdminBlogs from "./Admin/AdminBlogs";
 

// Context Providers
import { AuthProvider } from "./context/AuthContext";
import { CheckoutProvider } from "./context/CheckoutContext";
import { CartProvider } from "./context/CartContext";
import "./App.css";


function App() {
  return (
    <CartProvider>
      <CheckoutProvider>
        <AuthProvider>
          <Router>
            <ScrollToTop />
            <Routes>
              {/* Public Routes */}
              <Route
                path="/*"
                element={
                  <>
                    <Header />
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/shop-by-category" element={<ShopByCategory />} />
                      <Route path="/shop-by-brands" element={<ShopByBrands />} />
                      <Route path="/service-request" element={<ServiceRequestForm />} />
                      <Route path="/sales" element={<Sales />} />
                      <Route path="/trending-items" element={<TrendingItems />} />
                      <Route path="/top-discounts" element={<TopDiscountedProducts />} />
                      <Route path="/testimonials" element={<Testimonials />} />
                      <Route path="/login" element={<Login />} />
                      <Route path="/register" element={<Register />} />
                      <Route path="/wishlist" element={<Wishlist />} />
                      <Route path="/cart" element={<Cart />} />
                      <Route path="/productPage" element={<ProductPage />} />
                      <Route path="/product/:productId" element={<DescriptionPage />} />
                      <Route path="/checkout" element={<Checkout />} />
                      <Route path="/Paymentsuccess" element={<PaymentSuccess />} />
                      <Route path="/ordersPage" element={<OrdersPage />} />
                      <Route path="/forgot-password" element={<ForgotPassword />} />
                      <Route path="/verify-otp" element={<VerifyOtp />} />
                      <Route path="/reset-password" element={<ResetPassword />} />
                      <Route path="/profile" element={<Profile />} />
                      <Route path="/aboutUs" element={<AboutUs />} />      
                      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                      <Route path="/terms" element={<Terms />} />
                      <Route path="/OrderHistory" element={<OrderHistory />} />
                      <Route path="/ServiceHistory" element={<ServiceHistory />} />  
                      <Route path="/Content1" element={<Content1 />} />   
                      <Route path="/Content2" element={<Content2 />} />
                      <Route path="/embroidery-designs" element={<EmbroideryDesigns />} />
                      <Route path="/embroidery-design/:designId" element={<EmbroideryDesignDetail />} />
                      <Route path="/blog" element={<Blog />} />
                      <Route path="/blog/:blogId" element={<BlogDetail />} />
                      
                      
                      <Route path="/track-order/:orderId" element={<TrackOrder />} />
                    </Routes>
                    <Footer />
                  </>
                }
              />
              {/* Admin Routes - Protected with static login */}
              <Route path="/admin/*" element={<AdminProtectedRoute />}>
                <Route element={<AdminLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="users" element={<Users />} />
                  <Route path="technicians" element={<Technicians />} />
                  <Route path="products" element={<Products />} />
                  <Route path="settings" element={<Settings />} />
                  <Route path="banner" element={<Banner />} />
                  <Route path="reviews" element={<Reviews />} />
                  <Route path="trendingproducts" element={<TrendingProducts />} />
                  <Route path="serviceRequest" element={<AdminServiceRequest />} />
                  <Route path="orders" element={<Orders />} />
                  <Route path="categories" element={<Categories />} />
                  <Route path="brands" element={<Brands />} />
                  <Route path="offerBanner" element={<OfferBanner />} />
                  <Route path="reports" element={<Reports />} />
                  <Route path="AdminAboutUs" element={<AdminAboutUs />} />      
                  <Route path="AdminContent1" element={<AdminContent1 />} />   
                  <Route path="AdminContent2" element={<AdminContent2/>}/>
                  <Route path="locations" element={<TechnicianLocations />} />
                  <Route path="embroidery-designs" element={<AdminEmbroideryDesigns />} />
                  <Route path="blogs" element={<AdminBlogs />} />
                </Route>
              </Route>
            </Routes>
          </Router>
        </AuthProvider>
      </CheckoutProvider>
    </CartProvider>
  );
}

export default App;
